import Image, { ImageProps } from 'next/legacy/image';
import React, { useState, type JSX } from 'react';
import { defaultImage, loader } from '../../utils/images';

export interface RawImageProps extends ImageProps {
  raw?: boolean;
  UNSAFE_className?: string;
  fetchPriority?: React.ImgHTMLAttributes<HTMLImageElement>['fetchPriority'];
}

const ResponsiveImage = ({
  raw = false,
  alt,
  src,
  UNSAFE_className = '',
  fetchPriority = 'auto',
  ...props
}: RawImageProps): JSX.Element => {
  const [hasError, setHasError] = useState(false);

  if (raw && typeof src === 'string') {
    const width = parseInt(`${props.width}`, 10) || 0;
    const source = loader({ src, width });

    return (
      <img
        alt={alt || ''}
        src={hasError || !source ? defaultImage : source}
        className={`responsive-image ${UNSAFE_className}`}
        onError={() => setHasError(true)}
        loading={fetchPriority === 'high' ? 'eager' : 'lazy'}
        {...props}
      />
    );
  }

  return (
    <Image
      loader={loader}
      alt={alt || ''}
      src={hasError || !src ? defaultImage : src}
      className={`responsive-image ${UNSAFE_className}`}
      placeholder="blur"
      blurDataURL={defaultImage}
      onError={() => {
        setHasError(true);
      }}
      {...props}
      fetchPriority={fetchPriority}
    />
  );
};

export default ResponsiveImage;
